import axiosInstance from "./axiosInstance";
import { API_URL_All } from "./api";

const DEFAULT_MESSAGE_PAGE_SIZE = 30;

/** URL WebSocket /ws dùng chung cho header + inbox (subscribe_admin). */
export const buildAdminChatWebSocketUrl = () => {
  if (API_URL_All) {
    const normalizedBase = API_URL_All.replace(/\/$/, "");
    if (normalizedBase.startsWith("https://")) {
      return normalizedBase.replace("https://", "wss://") + "/ws";
    }
    if (normalizedBase.startsWith("http://")) {
      return normalizedBase.replace("http://", "ws://") + "/ws";
    }
  }
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  return protocol + "//" + window.location.host + "/ws";
};

export const getAdminChatSession = async (
  publicToken,
  limit = DEFAULT_MESSAGE_PAGE_SIZE
) => {
  const response = await axiosInstance.get(
    "/api/chat/public/session/" + publicToken,
    {
      params: { limit },
    }
  );
  return response.data;
};

export const getAdminChatMessages = async (
  publicToken,
  beforeMessageId,
  limit = DEFAULT_MESSAGE_PAGE_SIZE
) => {
  const response = await axiosInstance.get(
    "/api/chat/public/session/" + publicToken + "/messages",
    {
      params: { beforeMessageId, limit },
    }
  );
  return response.data;
};

export const sendAdminChatMessage = async (payload) => {
  const response = await axiosInstance.post("/api/chat/admin/message", payload);
  return response.data;
};

export const markAdminChatRead = async (publicToken) => {
  const response = await axiosInstance.post("/api/chat/admin/read/" + publicToken);
  return response.data;
};
